/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Canvas_Sign_In_Sent_TitleInputs */



/**
* | output |
* | --- |
* | "Check your inbox" |
*
* @param {Canvas_Sign_In_Sent_TitleInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const canvas_sign_in_sent_title = /** @type {((inputs?: Canvas_Sign_In_Sent_TitleInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Canvas_Sign_In_Sent_TitleInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Prüfen Sie Ihren Posteingang")
	return /** @type {LocalizedString} */ ("Check your inbox")
});